import React, { Component } from 'react';
import Nav from '../components/Nav';
import GetTheApp from '../components/GetTheApp';
import Footer from '../components/Footer';

class DownloadApp extends Component {

  componentDidMount() {
    document.body.className = 'background-blue';
  }

  componentWillUnmount() {
    document.body.className = '';
  }

  render() {
    return (
      <div>
        <div className="background-blue clearfix">
          <Nav />
        </div>

        <GetTheApp />
        <Footer />
      </div>
    );
  }
}

export default DownloadApp;



/** WEBPACK FOOTER **
 ** ./src/pages/DownloadApp.js
 **/